export function formatPrice(cents: number): string {
  const dollars = cents / 100;
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: Number.isInteger(dollars) ? 0 : 2,
    maximumFractionDigits: 2,
  }).format(dollars);
}

export function formatPriceParts(cents: number): {
  price: string;
  cents?: string;
  label: string;
} {
  const label = formatPrice(cents);
  if (cents % 100 === 0) {
    return { price: label, label };
  }
  const centsStart = label.length - 3;
  return {
    price: label.slice(0, centsStart),
    cents: label.slice(centsStart),
    label,
  };
}
